import { SagaMiddleware } from 'redux-saga'
import { cancel, fork, spawn, take } from 'redux-saga/effects'
import { SynchronizeActions } from '../reducers/synchronize/actionNames'
import { AuthorizationActions } from '../reducers/userAccount/actionNames'
import sagaCreateEvent from './bookingCalendar/createEvent'
import sagaCreateRoom from './bookingCalendar/createRoom'
import sagaDates from './bookingCalendar/dateRange'
import sagaDeleteEvent from './bookingCalendar/deleteEvent'
import sagaDeleteRoom from './bookingCalendar/deleteRoom'
import sagaRequestEvents from './bookingCalendar/eventsForCalendar'
import sagaApplyFiltering from './bookingCalendar/filtering'
import sagaCreateInvoice from './bookingCalendar/invoice/createInvoice'
import sagaLoadInvoice from './bookingCalendar/invoice/loadInvoice'
import sagaReloadInvoice from './bookingCalendar/invoice/reloadInvoice'
import sagaLoadCalendar from './bookingCalendar/loadCalendar'
import sagaLoadDictionary from './bookingCalendar/loadDictionary'
import sagaEvents from './bookingCalendar/loadEvents'
import sagaLoadProvenances from './bookingCalendar/loadProvenances'
import sagaLoadRooms from './bookingCalendar/loadRooms'
import sagaLoadServices from './bookingCalendar/loadServices'
import sagaAddServices from './bookingCalendar/Reservation/addService'
import sagaCalculatePrice from './bookingCalendar/Reservation/calculate'
import sagaChangeAdultsCount from './bookingCalendar/Reservation/changeAdultsCount'
import sagaChangeChildren from './bookingCalendar/Reservation/changeChildren'
import sagaChangeDate from './bookingCalendar/Reservation/changeDate'
import sagaClearFields from './bookingCalendar/Reservation/clearFields'
import sagaCopyAddressValues from './bookingCalendar/Reservation/copyAddressValues'
import sagaCopyReservation from './bookingCalendar/Reservation/copyReservation'
import sagaFieldVisibility from './bookingCalendar/Reservation/formConfiguration'
import sagaOnReservationFormChange from './bookingCalendar/Reservation/onChange'
import sagaOpenReservationModal from './bookingCalendar/Reservation/openReservationModal'
import sagaTransferEvent from './bookingCalendar/Reservation/transferEvent'
import sagaReservationValidate from './bookingCalendar/Reservation/validate'
import selectedColumns from './bookingCalendar/selectedColumns'
import sagaSortRooms from './bookingCalendar/sortRooms'
import sagaSummary from './bookingCalendar/summary'
import sagaUpdateEvent from './bookingCalendar/updateEvent'
import sagaUpdateRoom from './bookingCalendar/updateRoom'
import sagaGetClients from './clients/getClients'
import sagaOpenInfoModal from './clients/openInfoModal'
import sagaCurrency from './currency/loadCurrency'
import sagaLoadEventPdf from './events/loadEventPdf'
import sagaLoadEventsForList from './events/loadEventsForList'
import apiCaller from './fetchFactory'
import sagaFormActionsPromise from './form/formActionsPromise'
import sagaModalWorker from './modals'
import sagaRequestTemplateSend from './modals/templateSendModal'
import sagaLoadDictionaries from './paymentDictionary/loadDictionaries'
import sagaActivatePricelist from './price/activatePricelist'
import sagaCalculatePriceForm from './price/calculatePrice'
import sagaFetchPrices from './price/getPrices'
import sagaLoadConfiguration from './price/loadConfiguration'
import sagaSavePriceForm from './price/saveForm'
import sagaCopyPricelist from './price/copyPricelist'
import sageUpdateConfiguration from './price/updateConfiguration'
import sagaUpdateRoomPrices from './price/updateRoomPrices'
import sagaProvenances from './provenances/loadProvenances'
import sagaLoadSearch from './search/loadSearch'
import sagaGetStats from './stats/getStats'
import sagaFlushData from './synchronize/flushData'
import sagaSynchronize from './synchronize/synchronize'
import sagaNewVersion from './synchronize/version/newVersion'
import sagaReloadApp from './synchronize/version/reloadApp'
import sagaVersion from './synchronize/version/version'
import sagaLoadTask from './tasks/loadTask'
import sagaRestoreDefaultTemplates from './templates/defaultTemplates'
import sagaLoadTemplates from './templates/loadTemplates'
import sagaSaveTemplates from './templates/saveTemplates'
import sagaFireToasts from './toasts/fireToast'
import sagaAuth from './userAccount/authorize'
import sagaLoadEverything from './userAccount/loadEverything'
import sagaLoadLicense from './userAccount/loadLicense'
import sagaLoadLimits from './userAccount/loadLimits'
import sagaLoadUser from './userAccount/loadUser'
import sagaSaveReservationFormSettings from './userAccount/saveReservationFormSettings'
import sagaDeleteNotification from './userAccount/notifications/deleteNotifications'
import sagaLoadNotifications from './userAccount/notifications/loadNotifications'
import sagaMarkAsRead from './userAccount/notifications/markAsRead'
import sagaMarkAsSeen from './userAccount/notifications/markAsSeen'
import sagaSendNotificationError from './userAccount/notifications/sendError'
import sagaReloadOnTimezone from './userAccount/reloadOnTimezoneChange'
import sagaSwitchLanguage from './userAccount/switchLanguage'
import sagaUpdatePassword from './userAccount/updatePassword'
import sagaValidateOldPassword from './userAccount/validateOldPassword'
import sagaDeleteLogo from './userObject/deleteLogo'
import sagaObject from './userObject/loadUserProfile'
import sagaLoadUserSettings from './userObject/loadUserSettings'
import sagaUpdateLogo from './userObject/updateLogo'
import sagaSaveObject from './userObject/updateUserProfile'
import sageUpdateUserSettings from './userObject/updateUserSettings'
import sagaUserObjectId from './userObject/userObjectId'
import sagaValidateDateTime from './userObject/validateDateTime'
import sagaRequestTaxes from './paymentDictionary/loadTaxes'
import sagaRequestInvoiceSettings from './paymentDictionary/loadInvoiceSettings'
import sagaServices from './paymentDictionary/loadServices'
import sagaSavePayments from './paymentDictionary/savePayments'
import sagaPaymentMethod from './paymentDictionary/savePaymentMethod'
import sagaSavePictures from './pictures/savePrictures'
import sagaSaveWidgets from './widgets/widgets'
import sagaGetIntegration from './airbnb/getIntegration'
import sagaGetBoxBuyIntegration from './boxbuy/getBoxBuyIntegration'
import sagaCreateIntegration from './airbnb/createIntegration'
import sagaCreateBoxBuyIntegration from './boxbuy/createBoxBuyIntegration'
import sagaDisconnectBoxBuyIntegration from './boxbuy/disconnectBoxBuyIntegration'
import sagaGetListings from './airbnb/getListings'
import sagaToggleSync from './airbnb/setSync'
import sagaDeleteListings from './airbnb/disconnectListing'
import sagaFetchAirbnbPrices from './airbnb/getPrices'
import sageCreateListing from './airbnb/createListing'
import sageSubmitPricesAirbnb from './airbnb/submitPrices'
import sageLoadConfigurationAirbnb from './airbnb/getConfiguration'
import sagaSaveConfigurationAirbnb from './airbnb/saveConfiguration'
import sagaLoadFacilities from './facility/loadFacilities'
import sagaSaveFacilities from './facility/saveFacilities'
import sagaSetIcal from './ical/setIcalToken'
import sagaBooking from './booking/booking'
import sagaBookingMulti from './booking/bookingMulti'
import sagaSaveRentLicenses from './rentLicenses/loadRentLicenses'
import sagaLoadRentLicenses from './rentLicenses/saveRentLicenses'
import sagaDeleteRentLicenses from './rentLicenses/deleteRentLicense'
import sagaOverview from './overview/overview'
import sagaEmployees from './employees/employees'
import sagaOnboarding from './bookingCalendar/onbordingModal'
import sageGoogleHotel from './widgets/googleHotel'
import sagalogRocket from './userObject/logRocket'

const loginDependentSagas = function*() {
  yield fork(apiCaller)
  yield fork(sagaLoadEverything)
  yield fork(sagaLoadCalendar)
  yield fork(sagaEvents)
  yield fork(sagaLoadRooms)
  yield fork(sagaLoadLicense)
  yield fork(sagaDates)
  yield fork(sagaApplyFiltering)
  yield fork(sagaCreateRoom)
  yield fork(sagaUpdateRoom)
  yield fork(sagaDeleteRoom)
  yield fork(sagaCurrency)
  yield fork(sagaObject)
  yield fork(sagaSaveObject)
  yield fork(sagaLoadUser)
  yield fork(sagaSaveReservationFormSettings)
  yield fork(sagaLoadUserSettings)
  yield fork(sageUpdateUserSettings)
  yield fork(sagaUserObjectId)
  yield fork(sagaDeleteLogo)
  yield fork(sagaUpdateLogo)
  yield fork(sagaValidateDateTime)
  yield fork(selectedColumns)
  yield fork(sagaSummary)
  yield fork(sagaUpdatePassword)
  yield fork(sagaFlushData)
  yield fork(sagaProvenances)
  yield fork(sagaLoadDictionaries)
  yield fork(sagaValidateOldPassword)
  yield fork(sagaSortRooms)
  yield fork(sagaLoadServices)
  yield fork(sagaLoadProvenances)
  yield fork(sagaLoadDictionary)
  yield fork(sagaAddServices)
  yield fork(sagaChangeChildren)
  yield fork(sagaChangeDate)
  yield fork(sagaCalculatePrice)
  yield fork(sagaDeleteEvent)
  yield fork(sagaTransferEvent)
  yield fork(sagaRequestTemplateSend)
  yield fork(sagaCopyAddressValues)
  yield fork(sagaOpenReservationModal)
  yield fork(sagaOnReservationFormChange)
  yield fork(sagaChangeAdultsCount)
  yield fork(sagaCreateEvent)
  yield fork(sagaCopyReservation)
  yield fork(sagaUpdateEvent)
  yield fork(sagaLoadEventPdf)
  yield fork(sagaFieldVisibility)
  yield fork(sagaReservationValidate)
  yield fork(sagaClearFields)
  yield fork(sagaLoadSearch)
  yield fork(sagaLoadLimits)
  yield fork(sagaLoadNotifications)
  yield fork(sagaMarkAsRead)
  yield fork(sagaMarkAsSeen)
  yield fork(sagaDeleteNotification)
  yield fork(sagaSendNotificationError)
  yield fork(sagaFormActionsPromise)
  yield fork(sagaReloadApp)
  yield fork(sagaNewVersion)
  yield fork(sagaVersion)
  yield fork(sagaModalWorker)
  yield fork(sagaLoadInvoice)
  yield fork(sagaCreateInvoice)
  yield fork(sagaReloadInvoice)
  yield fork(sagaReloadOnTimezone)
  yield fork(sagaLoadConfiguration)
  yield fork(sageUpdateConfiguration)
  yield fork(sagaActivatePricelist)
  yield fork(sagaFetchPrices)
  yield fork(sagaCalculatePriceForm)
  yield fork(sagaSavePriceForm)
  yield fork(sagaCopyPricelist)
  yield fork(sagaUpdateRoomPrices)
  yield fork(sagaRequestEvents)
  yield fork(sagaLoadEventsForList)
  yield fork(sagaGetStats)
  yield fork(sagaGetClients)
  yield fork(sagaOpenInfoModal)
  yield fork(sagaLoadTask)
  yield fork(sagaLoadTemplates)
  yield fork(sagaSaveTemplates)
  yield fork(sagaRestoreDefaultTemplates)
  yield fork(sagaSynchronize)
  yield fork(sagaRequestTaxes)
  yield fork(sagaRequestInvoiceSettings)
  yield fork(sagaServices)
  yield fork(sagaSavePayments)
  yield fork(sagaPaymentMethod)
  yield fork(sagaSavePictures)
  yield fork(sagaSaveWidgets)
  yield fork(sagaGetIntegration)
  yield fork(sagaGetBoxBuyIntegration)
  yield fork(sagaCreateIntegration)
  yield fork(sagaDisconnectBoxBuyIntegration)
  yield fork(sagaCreateBoxBuyIntegration)
  yield fork(sagaGetListings)
  yield fork(sagaToggleSync)
  yield fork(sagaDeleteListings)
  yield fork(sagaFetchAirbnbPrices)
  yield fork(sageCreateListing)
  yield fork(sageSubmitPricesAirbnb)
  yield fork(sageLoadConfigurationAirbnb)
  yield fork(sagaSaveConfigurationAirbnb)
  yield fork(sagaLoadRentLicenses)
  yield fork(sagaSaveRentLicenses)
  yield fork(sagaDeleteRentLicenses)
  yield fork(sagaLoadFacilities)
  yield fork(sagaSaveFacilities)
  yield fork(sagaSetIcal)
  yield fork(sagaBooking)
  yield fork(sagaOverview)
  yield fork(sagaBookingMulti)
  yield fork(sagaOnboarding)
  yield fork(sagaEmployees)
  yield fork(sageGoogleHotel)
}

const rootSaga = function*() {
  yield spawn(sagaAuth)
  yield fork(sagaFireToasts)
  yield fork(sagaSwitchLanguage)
  yield fork(sagalogRocket)

  while (true) {
    yield take([
      AuthorizationActions.AuthorizationGranted,
      'Set notification service state',
    ])
    const afterLoginTask = yield fork(loginDependentSagas)
    yield take([
      AuthorizationActions.SignOffTheAccount,
      SynchronizeActions.FetchConsecutiveErrors,
    ])
    yield cancel(afterLoginTask)
  }
}

export default function(middleware: SagaMiddleware<{}>) {
  middleware.run(rootSaga)
}
